<template>
  <div class="m-5 md:m-15 2xl:m-20">
    <!-- Popup message alert if save is not possible (Evaluation in progress on this template) -->
    <EvalInProgress
      :evaluation-in-progress="evaluationInProgress"
      @showPreview="showPreview = true"
      @massAssignation="displayAssignTemplate()"
    />
    <!-- END Popup message alert -->

    <mass-template-assignation
      :opened="massAssignation"
      @close="massAssignation = false"
      :template="massAssignationTemplate"
    />

    <!-- BEGIN Popup confirm deactivate template -->
    <deactivate-template-popup
      :confirm-deactivate-template="confirmDeactivateTemplate"
      :template-name-to-deactivate="templateNameToDeactivate"
      :list-assigned-users-template="listAssignedUsersTemplate"
      :template-page-to-assign-after-delete="templatePageToAssignAfterDelete"
      @confirm_deactivate_template="
        (templatePageToAssignAfterDelete) => {
          confirm_deactivate_template(templatePageToAssignAfterDelete);
        }
      "
      @close="confirmDeactivateTemplate = -1"
    />
    <!-- END Popup confirm deactivate template -->

    <!-- BEGIN Popup confirm activate template -->
    <activate-template-popup
      :confirm-activate-template="confirmActivateTemplate"
      :template-name-to-deactivate="templateNameToDeactivate"
      @confirm_activate_template="confirm_activate_template()"
      @close="confirmActivateTemplate = -1"
    />
    <!-- END Popup confirm activate template -->

    <!-- Popup modal preview -->
    <popup
      :opened="showPreview"
      @close="showPreview = false"
    >
      <div class="m-5 md:m-15 2xl:m-20">
        <h3 class="mb-5 md:mb-15 2xl:mb-20">
          {{ infosPage.libelle_template }}
        </h3>
        <!-- Content modal -->
        <div class="flex flex-col">
          <!-- BEGIN List domaines -->
          <div
            class="flex flex-row self-center relative items-center cursor-pointer my-8 w-max max-w-7/12"
            @click="displayFieldList"
            @click.stop
          >
            <div class="flex flex-row items-end">
              <h5 class="text-indigo-600 font-normal">
                {{
                  'Domaine ' +
                    (currentField + 1) +
                    '. ' +
                    templateContent[currentField].libelle
                }}
              </h5>
            </div>
            <div
              class="text-pink-600 max-h-8 mr-auto rounded-full relative inline-flex items-center p-2 order-2"
            >
              <icon
                class="h-4 w-4"
                name="chevron-down"
              />
            </div>
            <div
              class="fieldlist flex z-20 mt-2 left-0 top-10 w-max max-w-full absolute rounded-md bg-white shadow-md shadow-gray-600 text-sm"
              v-click-outside="displayFieldList"
              v-if="showList"
            >
              <div class="mx-5 my-3">
                <div class="text-left">
                  <div
                    class="first:pt-2 py-1"
                    v-for="(field, i) in templateContent"
                    :key="i"
                  >
                    <p
                      class="text-gray-600 hover:text-gray-900"
                      @click="currentField = i"
                    >
                      <span>{{
                        'Domaine ' + (i + 1) + ' : ' + field.libelle
                      }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- END List domaines -->

          <!-- BEGIN criterions list -->
          <clea-skill
            v-for="(skill, index) in templateContent[currentField].skills"
            :key="index"
            class="my-8"
            :main-index="currentField"
            :secondary-index="index"
            :skill="skill"
            @checked="
              (index) => {
                skill.criterions[index].check = true;
              }
            "
            @unchecked="
              (index) => {
                skill.criterions[index].check = false;
              }
            "
          />
          <!--          <div
            v-for="(skill, index) in templateContent[currentField].skills"
            :key="index"
            class="my-8 grid grid-cols-4 content-center items-center border-blue-200 border-solid border rounded-lg"
          >
            <div
              class="col-span-1 text-indigo-600 text-lg font-normal flex justify-center py-5 px-10"
            >
              <p>
                {{
                  currentField + 1 + '-' + (index + 1) + '. ' + skill.libelle
                }}
              </p>
            </div>

            <div
              class="col-span-3 h-full border-blue-200 border-solid border-l flex items-center"
            >
              <div>
                <div
                  class="text-sm first:rounded-t-lg last:rounded-b-lg text-gray-900 odd:bg-white bg-indigo-100 bg-opacity-50 h-20 font-light"
                  v-for="(criteria, jndex) in skill.criterions"
                  :key="jndex"
                >
                  <div class="flex flex-row items-center h-20 w-full">
                    <p class="w-9/10 mx-5">
                      {{ criteria.value }}
                    </p>
                    <div class="mr-5 w-1/10 flex">
                      <checkbox-indigo
                        :name="'value' + index + jndex"
                        :value="skill.criterions[jndex].check"
                        @input="
                          (newValue) => {
                            skill.criterions[jndex].check = newValue;
                          }
                        "
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>-->
          <!-- END criterions list -->
        </div>
        <!-- END Content modal -->
      </div>
    </popup>
    <!-- END Popup modal preview -->

    <!-- Title -->
    <div class="mb-5 md:mb-15 2xl:mb-20">
      <h3>
        {{ this.infosPage.libelle_template }}
      </h3>
    </div>
    <!-- END Title -->

    <!-- BEGIN Bloc action buttons -->

    <list-buttons
      :evaluation-in-progress="evaluationInProgress"
      :is-active="infosPage.is_active"
      @preview="
        () => {
          showPreview = true;
        }
      "
      @deactivateTemplate="displayConfirmDeactivateTemplate()"
      @activateTemplate="displayConfirmActivateTemplate()"
      @assignTemplate="displayAssignTemplate()"
      :can-delete="false"
    />

    <!-- END Bloc action buttons -->

    <!-- Custom content -->
    <div class="mx-15">
      <!-- Contenu de la partie personnalisable -->
      <h3 class="text-lg text-gray-600">
        Le référentiel Cléa n'est pas modifiable.<br>
        Vous pouvez simplement
        <span v-if="$can(constants.PERMISSION_MODELE_DE_PAGE_DESACTIVER)">activer ou désactiver</span><span v-else>visualiser</span> le modèle de page.
      </h3>
      <div class="my-15 flex justify-center">
        <illustration name="notAllowed" />
      </div>
    </div>
    <!-- END Custom content -->
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';

import InputText from '../../components/Inputs/InputText';
import InputSelect from '../../components/Inputs/InputSelect';
import CheckboxForm from '../../components/Inputs/CheckboxForm';
import CheckboxIndigo from '../../components/Inputs/CheckboxIndigo';

import ActionButton from '../../components/ActionButton';
import ListButtons from './../../components/Templates/listButtons.vue';

import Icon from '../../components/Icon';
import Illustration from '../../components/Illustration';
import Popup from '../../components/Popup';

import ClickOutside from 'vue-click-outside';

import DeactivateTemplatePopup from './../../components/Templates/DeactivateTemplatePopup';
import ActivateTemplatePopup from './../../components/Templates/ActivateTemplatePopup';

import Constants from './../../constants';
import MassTemplateAssignation from './popups/MassTemplateAssignation.vue';
import CleaSkill from './CleaSkill.vue';
import EvalInProgress from './EvalInProgress.vue';

export default {
  name: 'ReferentielClea',

  components: {
    EvalInProgress,
    CleaSkill,
    MassTemplateAssignation,

    Icon,
    Popup,
    Illustration,

    ListButtons,
    DeactivateTemplatePopup,
    ActivateTemplatePopup,
  },

  data() {
    return {
      confirmDeactivateTemplate: -1,
      confirmActivateTemplate: -1,
      editName: false,
      showPreview: false,
      currentField: 0,
      showList: false,
      templateNameToDeactivate: '',
      massAssignation: false,
      massAssignationTemplate: {},
      constants: Constants,
    };
  },

  methods: {
    displayFieldList() {
      this.showList = !this.showList;
    },

    displayAssignTemplate() {
      this.massAssignationTemplate = {
        id: this.infosPage.id_template,
        name: this.infosPage.libelle_template,
        page_id: this.infosPage.id_page
      };
      this.massAssignation = true;
    },

    ...mapActions({
      save_datas: 'template/save_datas',
      switchState: 'template/switchState',
    }),
    ...mapMutations({
      SET_TEMPLATEVERSIONS: 'template/SET_TEMPLATEVERSIONS',
      SET_TEMPLATECONTENT: 'template/SET_TEMPLATECONTENT',
      SET_LIBELLE_TEMPLATE: 'template/SET_LIBELLE_TEMPLATE',
      SET_NAME_TEMPLATE_IN_LIST: 'template/SET_NAME_TEMPLATE_IN_LIST',
      SET_ISACTIVE: 'template/SET_ISACTIVE',
      SET_MESSAGEHEADER: 'template/SET_MESSAGEHEADER',
    }),

    editTemplateName() {
      if (
        !this.evaluationInProgress &&
        this.$can(Constants.PERMISSION_MODELE_DE_PAGE_EDITER)
      ) {
        this.editName = true;
      }
    },
    save_name() {
      if (
        !this.evaluationInProgress &&
        this.$can(Constants.PERMISSION_MODELE_DE_PAGE_EDITER)
      ) {
        this.SET_NAME_TEMPLATE_IN_LIST([
          this.infosPage.id_template,
          this.infosPage.libelle_template,
        ]);
        this.editName = false;
      }
    },
    displayConfirmDeactivateTemplate() {
      if (
        this.templatePageToAssignAfterDelete == null ||
        this.templatePageToAssignAfterDelete == undefined
      ) {
        this.SET_MESSAGEHEADER({
          type: 'error',
          msg: 'Vous ne pouvez pas désactiver le dernier modèle de ce type',
        });
        setTimeout(() => {
          this.SET_MESSAGEHEADER(null);
        }, 3000);
        return;
      }

      if (this.listAssignedUsersTemplate.length == 0) {
        this.confirmDeactivateTemplate = 0;
      }
      if (this.listAssignedUsersTemplate.length > 0) {
        this.confirmDeactivateTemplate = 2;
      }

      this.templateNameToDeactivate = this.infosPage.libelle_template;
    },

    displayConfirmActivateTemplate() {
      this.confirmActivateTemplate = 0;
      this.templateNameToDeactivate = this.infosPage.libelle_template;
    },

    confirm_deactivate_template(templateToReplace = null) {
      this.switchState({
        state: !this.infosPage.is_active,
        newTemplateToAssign: templateToReplace,
      });
      this.confirmDeactivateTemplate = 1;
    },

    confirm_activate_template() {
      this.switchState({
        state: !this.infosPage.is_active,
        newTemplateToAssign: null,
      });
      this.confirmActivateTemplate = 1;
    },
  },
  computed: {
    ...mapGetters({
      infosPage: 'template/infosPage',
      listPageTemplates: 'template/listPageTemplates',
      templateVersions: 'template/templateVersions',
      templateContent: 'template/templateContent',
      evaluationInProgress: 'template/evaluationInProgress',
      listAssignedUsersTemplate: 'template/listAssignedUsersTemplate',
    }),

    templatePageToAssignAfterDelete() {
      let nextPageTemplate = this.listPageTemplates.filter(
        (t) =>
          t.page_name == this.infosPage.name_page &&
          t.id != this.infosPage.id_template &&
          t.is_active == 1
      );
      return nextPageTemplate.length > 0 ? nextPageTemplate[0] : null;
    },
  },
  directives: {
    ClickOutside,
  },
};
</script>